import { Component } from 'san';
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';


import { IOrganization } from 'src/models';
import organizationService from 'src/services/organization.service';
import { ROOT_PARENT_ORG_NUMBER } from 'src/consts';
import { EOrgType } from 'src/enums';

const LEVEL_OFFSET = 24;

export default class OrganizationTree extends Component {
    constructor(options: any) {
        super(options);
    }

    initData() {
        return {
            items: [],
            checkedItem: null,
            type: null,
            q: '',
            searchQ$: new Subject<string>(),
            showSearch: false,   // []
            isCheckOrganization: false, // 若父组件是“选择组织部门”组件，局部添加滚动条
            orgTypeEnum: EOrgType
        };
    }

    inited() {
        this.getRootOrganizations();
        this.data
            .get('searchQ$')
            .pipe(debounceTime(300), distinctUntilChanged())
            .subscribe(() => {
                this.search();
            });
        this.watch('q', (value) => {
            this.data.get('searchQ$').next(value);
            if (!value) {
                this.dispatch('UI:clear-q', true);
            }
        });
    }

    search() {
        this.getOrganizations(this.data.get('q'));
    }

    clearQ() {
        this.data.set('q', '');
    }

    getOrganizations(q?: string) {
        organizationService.getOrganizations(q, false).then((organizations) => {
            organizations = organizationService.insertOrgTypeNameIntoOrganizations(organizations);
            const items = this.data.get('items');
            this.data.splice('items', [0, items.length, ...organizations]);
        });
    }

    check(item: IOrganization) {
        this.data.set('checkedItem', item);
        this.dispatch('UI:organization-tree-changed', item);
    }

    toggleExpand(item: IOrganization) {
        const items = this.data.get('items');
        const index = _.findIndex(items, { org_number: item.org_number });
        item = items[index];
        item._is_expand = !item._is_expand;
        if (item._is_expand) {
            if (item._has_loaded_children) {
                this.showOrHideChildren(items, item, true);
                this.data.splice('items', [0, items.length, ...items]);
                return;
            }
            item._has_loaded_children = true;
            this.data.splice('items', [index, 1, item]);
            this.getChildrenOrganizations(item);
        } else {
            this.showOrHideChildren(items, item, false);
            this.data.splice('items', [0, items.length, ...items]);
        }
    }

    private showOrHideChildren(items: IOrganization[], item: IOrganization, isShow: boolean) {
        const children: IOrganization[] = _.filter(items, { parent_org_number: item.org_number });
        _.forEach(children, (child) => {
            child._is_show = isShow;
            if (child._is_expand && child.has_children) {
                child._is_expand = isShow;
                this.showOrHideChildren(items, child, isShow);
            }
        });
    }

    // 获取一级组织
    getRootOrganizations() {
        organizationService
            .getChildrenOrganizations(ROOT_PARENT_ORG_NUMBER)
            .then((organizations) => {
                if (this.data.get('type')) {
                    organizations = _.filter(organizations, { type: this.data.get('type') });
                }
                organizations = organizationService.insertOrgTypeNameIntoOrganizations(organizations);
                // 添加交互属性
                _.forEach(organizations, (item) => {
                    item._is_expand = false;
                    item._level = 0;
                    item._is_show = true;
                    item._has_loaded_children = false;
                });
                const items = this.data.get('items');
                this.data.splice('items', [0, items.length, ...organizations]);
            });
    }

    // 获取子组织
    getChildrenOrganizations(organization: IOrganization) {
        console.log('org', organization);
        organizationService.getChildrenOrganizations(organization.org_number).then((children) => {
            _.forEach(children, (item) => {
                item._level = organization._level + 1;
                item._is_show = true;
                item._is_expand = false;
                item._has_loaded_children = false;
            });
            const items = this.data.get('items');
            const index = _.findIndex(items, { org_number: organization.org_number });
            this.data.splice('items', [index + 1, 0, ...children]);
            console.log(this.data.get('items'));
        });
    }

    // 计算缩进量
    getLeftOffset(item: IOrganization): string {
        return 'margin-left:' + item._level * LEVEL_OFFSET + 'px';
    }
}
